<forge-backdrop [visible]="overlay || page" id="spinnerOverlay" [ngClass]="spinnerOverLayClasses" [attr.fixed]="dialog ? 'true' : null">
</forge-backdrop>

<div *ngIf="!chart && !card && page" [ngClass]="progressSpinnerClasses" #busyIndicatorCard class="page" fxLayout="column" fxLayoutAlign="center center">
    <forge-card>
        <div fxLayout="column" fxLayoutAlign="center center">
            <forge-circular-progress>
            </forge-circular-progress>
            <span *ngIf="message" class="forge-typography--body2 busy-message">{{message}}</span>
        </div>
    </forge-card>
</div>

<forge-circular-progress *ngIf="!chart && !card && !page" class="basic">
</forge-circular-progress>

<div *ngIf="chart" fxLayout="column" fxLayoutAlign="space-between center" class="chart">
    <div fxLayout="row" fxLayoutAlign="space-between end">
        <div>
            <forge-skeleton class="h180p" text></forge-skeleton>
        </div>
        <div>
            <forge-skeleton class="h270p" text></forge-skeleton>
        </div>
        <div>
            <forge-skeleton class="h140p" text></forge-skeleton>
        </div>
        <div>
            <forge-skeleton class="h210p" text></forge-skeleton>
        </div>
        <div>
            <forge-skeleton class="h290p" text></forge-skeleton>
        </div>
        <div>
            <forge-skeleton class="h220p" text></forge-skeleton>
        </div>
        <div>
            <forge-skeleton class="h160p" text></forge-skeleton>
        </div>
    </div>
</div>

<forge-card *ngIf="card" class="card">
    <forge-skeleton form-field></forge-skeleton>
    <forge-skeleton form-field></forge-skeleton>
    <forge-skeleton form-field></forge-skeleton>
</forge-card>
